export default "__VITE_ASSET__8ABiQply__"